import { Cancel, Save } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, TextField } from '@mui/material';
import { useState, useEffect } from 'react';
import { IPlants, PlantsServices } from '../../../services/api/plants/PlantsServices';
import { useParams } from 'react-router-dom';

interface FormDialogProps {
    handleDialogChange: () => void;
    dialog: boolean;
    value: IPlants[];
    fetchData: () => void;
}

const initialData: IPlants = {
    data: '',
    arquivo: null, 
    descricao: '',
    id_barragem: '',
    uuid: '',
};

export const FormDialog = ({ handleDialogChange, dialog, fetchData }: FormDialogProps) => {
    const { dam } = useParams();
    const [valid, setValid] = useState<boolean>(false);
    const [data, setData] = useState<IPlants>(initialData);

    useEffect(() => {
        if (!dialog) {
            setData(initialData); 
            setValid(false);      
        }
    }, [dialog]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setValid(false);
        setData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            setData(prevData => ({
                ...prevData,
                arquivo: file
            }));
        }
    };

    function verifyForm() {
        return !!data.descricao && !!data.arquivo;
    }

    const onSave = () => {
        data.id_barragem = dam;
        if (verifyForm()) {
            PlantsServices.create(data)
                .then(response => {
                    if (response instanceof Error) {
                        console.log(response.message);
                    } else {
                        handleDialogChange(); 
                        fetchData();
                    }
                });
        } else {
            setValid(true);
        }
    };

    return (
        <Dialog open={dialog}>
            <DialogTitle>Planta ou Seção</DialogTitle>
            <DialogContent>
                <Box gap={1} display={'flex'} flexDirection={'column'} padding={1}>
                    <TextField
                        label='Data da Planta/Seção'
                        type='date'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        name='data'
                        value={data.data}
                        onChange={(e) => onChange(e)}
                    />
                    <TextField
                        label='Descrição'
                        type='text'
                        InputLabelProps={{ shrink: true }}
                        multiline={true}
                        rows={3}
                        fullWidth
                        name='descricao'
                        value={data.descricao}
                        onChange={(e) => onChange(e)}
                        error={valid ? (data.descricao == '' ? true : false) : false}
                        helperText={valid ? (data.descricao == '' ? 'Informe uma descrição' : null) : null}
                    />
                    <TextField
                        label='Arquivo'
                        type='file'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onChange={onFileChange}
                        name='arquivo'
                        inputProps={{ accept: '.jpg, .jpeg, .png' }}
                        error={valid ? (data.arquivo == null ? true : false) : false}
                        helperText='Deve ser uma imagem (.jpg .jpeg .png)'
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Box width={'100%'} display={'flex'} flexDirection={'row'} justifyContent={'end'} gap={1}>
                    <Button variant='outlined' color='error' onClick={handleDialogChange} startIcon={<Cancel />}  >
                        Cancelar
                    </Button>
                    <Button variant='outlined' color='success' startIcon={<Save />} onClick={onSave}>
                        Salvar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};